import { routes as printRoutes } from "./notes/tabs/prints/routes";
export const routes = (prefix = `theatre`) => [
    {
        path: `/${prefix}/operation-notes/create/:patientID/:visitNO`,
        name: `${prefix}.operation-notes.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.operation-notes.create`,
                PageDescription: "Theatre: Add operation Notes",
            },
        },
    },
    {
        path: `/${prefix}/operation-notes/create/:patientID/:visitNO/:procedureId/:itemId`,
        name: `${prefix}.operation-notes.create.procedure`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.operation-notes.create`,
                PageDescription: "Theatre: Add operation Notes",
            },
        },
    },
    ...printRoutes(prefix),
];
